import { followBusiness } from "./businessService";

function normalizeBusinessFromCampaign(campaign = {}) {
  const business = campaign?.business || {};
  const businessId = String(
    business?.id ||
    campaign?.businessId ||
    campaign?.raffle?.businessId ||
    campaign?.ticket?.businessId ||
    ""
  ).trim();
  if (!businessId) return null;
  return {
    id: businessId,
    displayName: String(business?.displayName || business?.name || business?.companyName || "").trim(),
    companyName: String(business?.companyName || business?.name || business?.displayName || "").trim(),
    name: String(business?.name || business?.companyName || business?.displayName || "").trim(),
    avatarUrl: String(business?.avatarUrl || business?.logoUrl || "").trim(),
    logoUrl: String(business?.logoUrl || business?.avatarUrl || "").trim(),
  };
}

export async function followCampaignBusiness(userId, campaign = {}) {
  const uid = String(userId || "").trim();
  const business = normalizeBusinessFromCampaign(campaign);
  if (!uid || !business) return false;
  await followBusiness(uid, business);
  return true;
}
